module.exports = __webpack_public_path__ + "media/images/icons/ban-b24407cf8933c856cb6ac36a13bfae2f.svg";